import {
  ComponentSelection,
  isTraversalLoadedState,
  LoadedState,
  QueryBuilderQuery,
} from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import { setTraversalContextComponent } from 'loadedState/actions';
import { loadedStateOperations } from 'loadedState/loadedStateOperations';

export const setComponentSelectionForLoadedState = (
  loadedState: LoadedState,
  componentSelection: ComponentSelection
): void => {
  // A created-items dataset holds its components directly and has no start
  // context to resolve, so there is nothing to set.
  if (!isTraversalLoadedState(loadedState)) return;
  dispatchAction(
    setTraversalContextComponent({
      loadedStateHash: loadedStateOperations.stateToHash(loadedState),
      componentSelection,
    })
  );
};

export const setStartQueryForLoadedState = (
  loadedState: LoadedState,
  startQuery: QueryBuilderQuery
): void => {
  const componentSelection: ComponentSelection = {
    startSet: [],
    startQuery,
  };
  setComponentSelectionForLoadedState(loadedState, componentSelection);
};

export const setStartSetForLoadedState = (
  loadedState: LoadedState,
  startSet: string[]
): void => {
  const componentSelection: ComponentSelection = {
    startSet,
  };
  setComponentSelectionForLoadedState(loadedState, componentSelection);
};
